// extracted by mini-css-extract-plugin
export default {"input":"UpdateDialog__input___Sd-1o"};